import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import './contact_section_style.scss';


export const ContactSection = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [topic, setTopic] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSucceed, setIsSucceed] = useState(false);
    const navigate = useNavigate();
    const [globalOptions, setGlobalOptions] = useState(null);

    useEffect(() => {
        fetchGlobalOptions();

        document.getElementById('phone_number').addEventListener('input', function (e) {
            var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            setPhoneNumber(!x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
        });
    }, []);

    const fetchGlobalOptions = async () => {
        try {
          const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_global_site_options");
          setGlobalOptions(data);
          console.log("data-", data)
        } catch (e) {
          setGlobalOptions(null);
        }
    }



   

    const onSubmitForm = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            await axios.post(
                '/wp-json/gf/v2/forms/1/submissions', // Replace {form_id} with your actual Gravity Form ID
                {
                    'input_1': firstName,
                    'input_3': lastName,
                    'input_4': emailAddress,
                    'input_5': phoneNumber,
                    'input_6': topic,
                    'input_7': message,
                    'input_8': window.location.href
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                }
            );
            setIsSucceed(true);
            NotificationManager.success('Form has been submitted successfully!', 'Success!');
            setFirstName('');
            setLastName('');
            setPhoneNumber('');
            setEmailAddress('');
            setTopic('');
            setMessage('');
            navigate(globalOptions?.data?.button_link ? globalOptions?.data?.button_link : '/thank-you/');

        } catch (err) {
            console.log(err);
        } finally {
            setIsSubmitting(false);
        }
        return false;
    }

    const isFormValid = firstName !== '' && lastName !== '' && emailAddress !== '' && phoneNumber !== '' && topic !== '' && message !== '';

    return <section id="contact-section" className="home-section">
        <div className="container">
            <div className='inner-wrapper'>
                <span className='main-category'>Contact Us</span>
                <h2>
                    <span className='title-first'>Ready to</span>
                    <span className='title-second'>Work With Us?</span>
                </h2>
                <form onSubmit={onSubmitForm}>
                    <div className='form-heading'>
                        {
                            isSucceed && <h3>Form has been sent successfully!</h3>
                        }
                    </div>
                    <div className='form-fields'>
                        <div className='form-field'>
                            <input 
                                required
                                type="text" 
                                name="first_name" 
                                id="first_name" 
                                placeholder='First Name *'
                                value={firstName} 
                                onChange={(e) => {
                                    setFirstName(e.target.value)
                                }}
                            />
                        </div>
                        <div className='form-field'>
                            <input
                                required
                                type="text"
                                name="last_name"
                                id="last_name"
                                placeholder='Last Name *'
                                value={lastName} 
                                onChange={(e) => {
                                    setLastName(e.target.value)
                                }}
                            />
                        </div>
                        <div className='form-field'>
                            <input 
                                required
                                type="email" 
                                name="email_address" 
                                id="email_address" 
                                placeholder='Email Address *'
                                value={emailAddress}
                                onChange={(e) => {
                                    setEmailAddress(e.target.value)
                                }}
                            />
                        </div>
                        <div className='form-field'>
                            <input 
                                required
                                type="text" 
                                name="phone_number" 
                                id="phone_number" 
                                placeholder='Phone Number *'
                                value={phoneNumber}
                                onChange={(e)=>{
                                    setPhoneNumber(e.target.value)
                                }}
                            />
                        </div>
                        <div className='form-field'>
                            <select placeholder="Select" required onChange={(e) => {
                                setTopic(e.target.value);
                            }}>
                                <option value="">Select</option>
                                <option value="Divorce">Divorce</option>
                                <option value="Child Custody/Parenting Plan">Child Custody/Parenting Plan</option>
                                <option value="Child Support">Child Support</option>
                                <option value="Prenuptial Agreement">Prenuptial Agreement</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className='form-field'>
                            <textarea 
                                name='message' 
                                id="message" 
                                placeholder='Leave us a message'
                                value={message}
                                onChange={(e) => {
                                    setMessage(e.target.value)
                                }}
                            />
                        </div>
                    </div>

                    <div className='form-footer'>
                        <button tyoe="submit" className={`button ${(!isFormValid || isSubmitting) ? 'disabled' : ''}`}>
                            {isSubmitting ? 'Sending...' : 'Submit Now'}
                        </button>
                    </div>
                </form>
            </div>
       </div>
    </section>
}